export const currentSchoolYear = "2024-2025";
